import throttle from "@lodash/throttle"
import debounce from "@lodash/debounce"

document.addEventListener('DOMContentLoaded', () => {
  console.log('foo')
  const $header = document.querySelector('nova-header')
  const $openMenus = $header.querySelectorAll('.js-menu-toggle')
  const $openCarts = $header.querySelectorAll('.js-cart-toggle')
  const $drawerButtons = $header.querySelectorAll('.js-header-drawer-button')
  const $mobileMenu = document.querySelector('#mobile-menu')
  const $headerDrawer = $header.querySelectorAll('.js-header-drawer')
  const $accordions = document.querySelectorAll('component-accordion')

  $mobileMenu?.addEventListener('sl-after-hide', () => {
    $openMenus.forEach(item => item.classList.remove('open'))
  })

  $openMenus.forEach(item => {
    item.addEventListener('click', () => {
      item.classList.toggle('open')
      if (item.classList.contains('open'))
        document.dispatchEvent(new CustomEvent('nova:mobile-menu:open'))
      else
        document.dispatchEvent(new CustomEvent('nova:mobile-menu:close'))
    })
  })

  $openCarts.forEach(item => {
    item.addEventListener('click', () => {
      document.dispatchEvent(new CustomEvent('nova:cart:open'));
    })
  })

  const handleDrawerAttributesAndEvents = (event) => {
    const $drawer = event.target.closest('.js-header-drawer')
    if (!$drawer) return
    const targetReference = $drawer.id
    const $button = $header.querySelector(`[data-target="${targetReference}"]`)
    const $buttonOpenIcon = $button.querySelector('.js-header-drawer-icon-open')
    const $buttonCloseIcon = $button.querySelector(
      '.js-header-drawer-icon-close',
    )
    if (!$button) return
    if (event.type === 'sl-hide') {
      $drawer.removeAttribute('is-open')
      $button.removeAttribute('is-open')
      if ($buttonOpenIcon && $buttonCloseIcon) {
        $buttonOpenIcon.classList.remove('visually-hidden')
        $buttonOpenIcon.dataset.tabIndex = 0
        $buttonCloseIcon.classList.add('visually-hidden')
        $buttonCloseIcon.dataset.tabIndex = -1
      }
      dispatchDrawerHideEvent($drawer)
    } else if (event.type === 'sl-show') {
      $drawer.setAttribute('is-open', '')
      $button.setAttribute('is-open', '')
      if ($buttonOpenIcon && $buttonCloseIcon) {
        $buttonOpenIcon.classList.add('visually-hidden')
        $buttonOpenIcon.dataset.tabIndex = -1
        $buttonCloseIcon.classList.remove('visually-hidden')
        $buttonCloseIcon.dataset.tabIndex = 0
      }
      dispatchDrawerShowEvent($drawer)
    }
  }

  const dispatchDrawerShowEvent = (target) => {
    window.dispatchEvent(
      new CustomEvent('nova:header-drawer:open', {
        bubbles: true,
        detail: { target: target },
      }),
    )
  }

  const dispatchDrawerHideEvent = (target) => {
    window.dispatchEvent(
      new CustomEvent('nova:header-drawer:close', {
        bubbles: true,
        detail: { target: target },
      }),
    )
  }

  for (const $drawer of $headerDrawer) {
    $drawer.addEventListener('sl-hide', handleDrawerAttributesAndEvents)
    $drawer.addEventListener('sl-show', handleDrawerAttributesAndEvents)
  }

  const closeAccordions = debounce(
    ($accordion) => {
      if (
        $accordion.animationState != 'idle' ||
        $accordion.isFullyOpen === $accordion.isFullyClosed
      ) {
        return
      }
      $accordion.open = false
    },
    266,
    { leading: true, trailing: true }
  )

  const toggleAccordion = (event) => {
    const target = event.target
    const $accordion = target.closest('component-accordion')

    if (
      $accordion.animationState != 'idle' ||
      $accordion.isFullyOpen === $accordion.isFullyClosed
    ) {
      return
    }

    switch (event.type) {
      case 'pointerenter': {
        if (!$accordion.isOpen) {
          $accordion.setAttribute('data-open-event', event.type)
          $accordion.open = true
        }
        break
      }
      case 'pointerleave': {
        // if ($accordion.dataset.openEvent !== 'click') {
        //   $accordion.open = false
        // }
        $accordion.open = false
        break
      }
      case 'keydown': {
        $accordion.open = false
        break
      }
      case 'click': {
        if ($accordion._trigger?.contains(target)) {
          if (!$accordion.open) {
            $accordion.setAttribute('data-open-event', event.type)
          }
          $accordion.open = !$accordion.open
        }
        break
      }
      default:
        if (!$accordion.open) {
          $accordion.setAttribute('data-open-event', event.type)
        }
        $accordion.open = !$accordion.open
        break
    }

    $accordion.closeOthers()
  }
  const debounceOpenAccordion = debounce(toggleAccordion, 266, {
    leading: false,
    trailing: true,
  })
  const throttleOpenAccordion = throttle(toggleAccordion, 266, {
    leading: true,
    trailing: true,
  })

  for (const $accordion of $accordions) {
    $accordion.addEventListener('pointerenter', throttleOpenAccordion)
    $accordion.addEventListener('pointerleave', debounceOpenAccordion)
    $accordion.addEventListener('click', (event) => {
      const target = event.target
      const $accordion = target.closest('component-accordion')
      if (event.type === 'click' && !$accordion.isFullyOpen) {
        $accordion.setAttribute('data-open-event', event.type)
      }
      throttleOpenAccordion(event)
    })

    $accordion.addEventListener('keydown', (e) => {
      const escKey = e.key == 'Escape' || e.key === 'Esc' || e.keyCode === 27
      if (!e.repeat && escKey) {
        throttleOpenAccordion(e)
      }
    })
  }

  document.addEventListener('accordion:closeOthers', ({ target }) => {
    for (const $accordion of $accordions) {
      if ($accordion.id != target.id && $accordion.open) {
        closeAccordions($accordion)
      }
    }
  })
})
